// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#outing-list[data-v-2487b5d8]{max-width:1280px;margin-left:auto;margin-right:auto}#outing-list .register-btn[data-v-2487b5d8],#outing-list .setting-btn[data-v-2487b5d8]{min-width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
